module.exports = __webpack_public_path__ + "static/media/vuetranslator.86f21343.png";